<div class="modal-header">
    <h4 class="modal-title">Replanifier le ticket {{exam.voucher_code}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div *ngIf="isDataLoading" class="text-center">
        <span class="button-loader"></span>
    </div>

    <form [formGroup]="rescheduleForm" *ngIf="!isDataLoading">
        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-right">Candidat</label>
            <div class="col-sm-8">
                <p class="form-control-plaintext">{{exam.student?.fullName}}</p>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-right">Session actuelle</label>
            <div class="col-sm-8">
                <p class="form-control-plaintext">
                    <ng-container *ngIf="exam.session; else noSession">
                        {{exam.session.code}} – {{exam.session.date | date:'dd/MM/yyyy HH:mm'}}
                    </ng-container>
                    <ng-template #noSession>Aucune</ng-template>
                </p>
            </div>
        </div>
        <div class="form-group row">
            <label for="rescheduleSessionSelect" class="col-sm-4 col-form-label text-right">Nouvelle session</label>
            <div class="col-sm-8">
                <select *ngIf="sessions.length > 0" class="form-control" formControlName="sessionId" id="rescheduleSessionSelect">
                    <option [ngValue]="null" disabled>Sélectionnez une session</option>
                    <option *ngFor="let session of sessions" [ngValue]="session.id">
                        {{session.code}} – {{session.date | date:'dd/MM/yyyy HH:mm'}} – {{session.centerName}}{{session.isRemote ? ' (distanciel)' : ''}}
                        ({{session.nbExams}}<ng-container *ngIf="session.nbMaxCandidates > 0">/{{session.nbMaxCandidates}}</ng-container>)
                    </option>
                </select>
                <p *ngIf="sessions.length === 0" class="form-control-plaintext text-muted">
                    Aucune session à venir compatible avec ce ticket.
                </p>
                <small *ngIf="selectedSession?.isFull" class="text-warning">
                    Session complète ({{selectedSession.nbExams}}/{{selectedSession.nbMaxCandidates}})
                </small>            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-right" [attr.for]="selectedSession && canSendConvocation ? 'rescheduleSendConvocationInput' : null">Convocation</label>
            <div class="col-sm-8">
                <ng-container *ngIf="selectedSession; else noSessionSelected">
                    <div *ngIf="canSendConvocation" class="form-check col-form-label">
                        <input class="form-check-input" type="checkbox" id="rescheduleSendConvocationInput" formControlName="sendConvocation">
                        <label class="form-check-label" for="rescheduleSendConvocationInput">
                            Envoyer la convocation pour la nouvelle session
                        </label>
                    </div>
                    <p *ngIf="!exam.preregistration" class="form-control-plaintext text-muted">
                        Aucune pré-inscription n'est associée à ce ticket : la convocation ne peut pas être envoyée.
                    </p>
                    <p *ngIf="exam.preregistration && !exam.certification" class="form-control-plaintext text-muted">
                        Aucune certification n'est associée à ce ticket : la convocation ne peut pas être envoyée.
                    </p>
                </ng-container>
                <ng-template #noSessionSelected>
                    <p class="form-control-plaintext text-muted">
                        Sélectionner une session pour activer l'envoi d'une convocation
                    </p>
                </ng-template>
            </div>
        </div>

        <div *ngIf="selectedSession && exam.studentConfirmedAt" class="alert alert-warning mb-0">
            La confirmation de participation du candidat du {{exam.studentConfirmedAt | date:'dd/MM/yyyy à HH:mm'}} sera annulée.
        </div>
    </form>

    <div *ngIf="error" class="alert alert-danger mt-3">
        {{error}}
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-danger" (click)="activeModal.dismiss()">
        Annuler
    </button>
    <button type="button" class="btn btn-outline-success" (click)="validate()"
        [disabled]="isDataLoading || submitting || rescheduleForm.invalid">
        <span *ngIf="submitting" class="button-loader"></span>
        Valider
    </button>
</div>
